import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Breadcrumbs } from "../components/Breadcrumbs";
import { useAuth } from "../context/AuthContext";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../components/ui/tabs";
import { useSeo } from "../lib/seo";

export default function Account() {
  const { login, register } = useAuth();
  const navigate = useNavigate();
  const [li, setLi] = useState({ email: "", password: "" });
  const [reg, setReg] = useState({ name: "", email: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useSeo({
    title: "Sign in or create an account | ProfitMigo",
    description: "Create a free ProfitMigo account to save products and track their profit and margin in one place.",
    path: "/account",
    robots: "noindex, follow",
  });

  const doLogin = async () => {
    setError(""); setLoading(true);
    const res = await login(li.email, li.password);
    setLoading(false);
    if (res.ok) navigate("/products"); else setError(res.error);
  };

  const doRegister = async () => {
    setError(""); setLoading(true);
    const res = await register(reg.email, reg.password, reg.name);
    setLoading(false);
    if (res.ok) navigate("/products"); else setError(res.error);
  };

  return (
    <div className="mx-auto max-w-md px-4 py-12 sm:px-6">
      <Breadcrumbs items={[{ label: "Home", to: "/" }, { label: "Account" }]} />
      <h1 className="font-display text-3xl font-bold tracking-tight">Your account</h1>
      <p className="mt-2 text-sm text-muted-foreground">Save products and track their profitability. Free — the calculators stay free too.</p>

      <Tabs defaultValue="login" className="mt-6" onValueChange={() => setError("")}>
        <TabsList className="w-full">
          <TabsTrigger value="login" className="flex-1" data-testid="tab-login">Sign in</TabsTrigger>
          <TabsTrigger value="register" className="flex-1" data-testid="tab-register">Create account</TabsTrigger>
        </TabsList>

        {error && <p className="mt-4 text-sm text-destructive" data-testid="account-error">{error}</p>}

        <TabsContent value="login" className="mt-4 space-y-4">
          <div className="space-y-1.5">
            <Label htmlFor="login-email">Email</Label>
            <Input id="login-email" type="email" data-testid="account-email" value={li.email} onChange={(e) => setLi((p) => ({ ...p, email: e.target.value }))} />
          </div>
          <div className="space-y-1.5">
            <Label htmlFor="login-password">Password</Label>
            <Input id="login-password" type="password" data-testid="account-password" value={li.password} onChange={(e) => setLi((p) => ({ ...p, password: e.target.value }))} />
          </div>
          <Button className="w-full" onClick={doLogin} disabled={loading} data-testid="account-login-button">
            {loading ? "Signing in…" : "Sign in"}
          </Button>
        </TabsContent>

        <TabsContent value="register" className="mt-4 space-y-4">
          <div className="space-y-1.5">
            <Label htmlFor="reg-name">Name</Label>
            <Input id="reg-name" data-testid="account-reg-name" value={reg.name} onChange={(e) => setReg((p) => ({ ...p, name: e.target.value }))} />
          </div>
          <div className="space-y-1.5">
            <Label htmlFor="reg-email">Email</Label>
            <Input id="reg-email" type="email" data-testid="account-reg-email" value={reg.email} onChange={(e) => setReg((p) => ({ ...p, email: e.target.value }))} />
          </div>
          <div className="space-y-1.5">
            <Label htmlFor="reg-password">Password</Label>
            <Input id="reg-password" type="password" data-testid="account-reg-password" value={reg.password} onChange={(e) => setReg((p) => ({ ...p, password: e.target.value }))} />
          </div>
          <Button className="w-full" onClick={doRegister} disabled={loading} data-testid="account-register-button">
            {loading ? "Creating…" : "Create account"}
          </Button>
        </TabsContent>
      </Tabs>
    </div>
  );
}
